import React from 'react';
import { SubNavLink } from './NavBar.styles';
import { NavItemConfig } from './NavBar.types';

interface SubNavItemProps {
  child: NavItemConfig;
}

export const SubNavItem: React.FC<SubNavItemProps> = ({ child }) => {
  return (
    <li>
      <SubNavLink to={child.path} exact={child.exact} activeClassName="active">
        {child.title}
      </SubNavLink>
    </li>
  );
};
